import { render, staticRenderFns } from "./AppRouter.vue?vue&type=template&id=86564f18&"
import script from "./AppRouter.vue?vue&type=script&lang=js&"
export * from "./AppRouter.vue?vue&type=script&lang=js&"
import style0 from "./AppRouter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports